'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _components = require('components');

var _utils = require('utils');

var _Columns = require('@quixeltools/quixel-ui-library/dist/components/common/website/Columns');

var _Columns2 = _interopRequireDefault(_Columns);

var _TextInput = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput');

var _TextInput2 = _interopRequireDefault(_TextInput);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fieldRow = (0, _glamor.css)({
  display: 'block',
  marginBottom: (0, _css.unitRem)(1)
});

var AddressFormFields = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AddressFormFields, _React$Component);

  function AddressFormFields(props) {
    (0, _classCallCheck3.default)(this, AddressFormFields);
    return (0, _possibleConstructorReturn3.default)(this, (AddressFormFields.__proto__ || (0, _getPrototypeOf2.default)(AddressFormFields)).call(this, props));
  }

  (0, _createClass3.default)(AddressFormFields, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var onVATCheck = this.props.onVATCheck;
      var country = this.props.fields.country;


      if (onVATCheck && country && country.value) {
        onVATCheck(country.value);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          onVATCheck = _props.onVATCheck,
          validatingVat = _props.validatingVat;
      var newCountry = nextProps.fields.country;
      var oldCountry = this.props.fields.country;


      if (onVATCheck && newCountry && newCountry.value && newCountry.value !== (oldCountry && oldCountry.value) || !!this.props.fields.vatNo.value !== !!nextProps.fields.vatNo.value) {
        onVATCheck(newCountry.value, nextProps.fields.vatNo.valid && nextProps.fields.vatNo.value);
      }
    }
  }, {
    key: 'renderCountryOptions',
    value: function renderCountryOptions() {
      var countryList = (0, _utils.getCountryList)();

      return countryList.important && countryList.important.length ? [countryList.important.map(function (c) {
        return _react2.default.createElement(
          'option',
          { value: c.code, key: c.code },
          c.name
        );
      }), _react2.default.createElement(
        'option',
        { disabled: true, key: 'disabled' },
        '-------------------------'
      ), countryList.rest.map(function (c) {
        return _react2.default.createElement(
          'option',
          { value: c.code, key: c.code },
          c.name
        );
      })] : countryList.rest.map(function (c) {
        return _react2.default.createElement(
          'option',
          { value: c.code, key: c.code },
          c.name
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          disabled = _props2.disabled,
          lockCountryAndVat = _props2.lockCountryAndVat,
          validatingVat = _props2.validatingVat,
          _props2$fields = _props2.fields,
          name = _props2$fields.name,
          company = _props2$fields.company,
          city = _props2$fields.city,
          address = _props2$fields.address,
          postalCode = _props2$fields.postalCode,
          country = _props2$fields.country,
          vatNumberField = _props2$fields.vatNo;


      var vatNumber = (0, _extends3.default)({}, vatNumberField, { validating: validatingVat });

      var countryValue = country.value;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _Columns2.default,
          { n: 2, gutter: 4, className: fieldRow },
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ simpleError: true, disabled: disabled, label: 'Name' }, name)),
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ simpleError: true, disabled: disabled, label: 'Company' }, company))
        ),
        _react2.default.createElement(
          _Columns2.default,
          { n: 2, gutter: 4, className: fieldRow },
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ simpleError: true, disabled: disabled, label: 'Address' }, address)),
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ simpleError: true, disabled: disabled, label: 'City' }, city))
        ),
        _react2.default.createElement(
          _Columns2.default,
          { n: 2, gutter: 4, className: fieldRow },
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ simpleError: true, disabled: disabled, label: 'Postal Code' }, postalCode)),
          _react2.default.createElement(
            _components.FormSelect,
            (0, _extends3.default)({
              label: 'Country' }, country, {
              disabled: lockCountryAndVat || disabled
            }),
            this.renderCountryOptions()
          )
        ),
        (0, _utils.isEUCountry)(countryValue) && !(lockCountryAndVat && !vatNumber.value) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
            label: 'Registered EU Business',
            placeholder: 'EU VAT ID',
            disabled: lockCountryAndVat || disabled
          }, vatNumber))
        )
      );
    }
  }]);
  return AddressFormFields;
}(_react2.default.Component), _class.propTypes = {
  fields: _react2.default.PropTypes.object,
  lockCountryAndVat: _react2.default.PropTypes.bool,
  disabled: _react2.default.PropTypes.bool
}, _temp);
exports.default = AddressFormFields;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressFormFields/AddressFormFields.jsx
// module id = 2151
// module chunks = 0